import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export interface AgentData {
  title: string;
  runtimeStatus: {
    status: string;
    log: string;
    error: string;
    attributes: Record<string, unknown>;
  };
  revision: number;
  documentation?: string;
  revisionHistory?: {
    revision: number;
    date: number;
    comment: string;
    changedBy: string;
  }[];
  code?: string;
  codePrevious?: string;
  codeLanguage?: string;
  imageUrl?: string;
  runtimeVersion?: number;
  configurationVariables?: string[];
  vaultSchemas?: {
    uuid: string;
    container: string;
    label?: string;
    variableName?: string;
  }[];
  previousVaultMappings?: Record<string, { uuid: string; container: string; label?: string }>;
}

export function useGetAgent(uuid: string, options?: any) {
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['agent', uuid],
    queryFn: async (): Promise<AgentData> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/get_agent`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ uuid }),
        }
      );

      const data = await response.json();

      return data?.data;
    },
    ...options,
  });
}
